@use 'src/global/variables.scss' as var;

c-form-progress {
    .vertical-svg-container {
        padding-top: 20px;

        #Ebene_1 {
            margin-bottom: 30px;
        }

        svg {
            width: 50px;
            height: 50px;
            color: white;
            border-radius:50%;
            border: solid white 2px;
            float: left;
            margin: 0;
            padding: 0px;
        }

        h3 {
            width: calc(94% - 50px);
            padding: 18px;
            margin: 0 0 0 22%;
            font-size: 0.9em;
        }

        span {
            width: 100%;
            float: left;
        }

        .vr-line {
            background-color: white;
            width: 2px;
            height: 20px;
            float: left;
            padding: 0px;
            margin-left: 7.5%;
        }
    }

    .horizontal-svg-container {
        margin: 15px 0 20px 5%;

        span {
            float: left;
        }
      
        svg {
            width: 60px;
            color: var.$primary-color;
            border-radius:50%;
            border: solid var.$primary-color 2px;
        }

        .hr-line {
            background-color: var.$primary-color;
            height: 2px;
            width: 15px;
            float: left;
            margin-top: 7.5%;
        }

        #GC {
            position: relative;
            width: 25px;
            z-Index: 1;
            margin: -25px -4px 40px -25px;
            border-color: green;
            background-color: green;
            color: white;
        }

        .SVG1 {
            background-color: var.$primary-color;
            color: white !important;
        }

        .SVG2 {
            background-color: var.$primary-color;
            color: white !important;
        }

        .SVG3 {
            background-color: var.$primary-color;
            color: white !important;
        }

        .SVG4 {
            background-color: var.$primary-color;
            color: white !important;
        }

        .SVG1F {
            background-color: white;
            color: var.$primary-color !important;
        }

        .SVG2F {
            background-color: white;
            color: var.$primary-color !important;
        }

        .SVG3F {
            background-color: white;
            color: var.$primary-color !important;
        }

        .SVG4F {
            background-color: white;
            color: var.$primary-color !important;
        }

        .SVG5F {
            background-color: white;
            color: var.$primary-color !important;
        }
    }
}